import { Pipe, PipeTransform } from '@angular/core';

import { DeviceLicenseState } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceLicenseStateTextService } from '@shure/shared-angular-features-device-license-utils';

@Pipe({ name: 'licenseStateTitlePipe', pure: true, standalone: true })
export class LicenseStateTitlePipe implements PipeTransform {
	constructor(private readonly deviceLicenseStateTextService: DeviceLicenseStateTextService) {}

	/* istanbul ignore next */
	public transform(deviceLicenseState: DeviceLicenseState | undefined): string {
		return this.deviceLicenseStateTextService.getTitle(deviceLicenseState);
	}
}
